/* eslint-disable no-undef */
import React, { useState, useCallback, useMemo, useEffect } from 'react';



import { useNavigate } from 'react-router-dom';



import { useAuth } from '../hooks/useAuth';



import MainLayout from '../components/layout/MainLayout';



import AgendaModuleFonctionnel from '../components/comptabilite/AgendaModuleFonctionnel';



import PointageModule from '../components/shared/PointageModule';
import GenerationCodeModule from '../components/shared/GenerationCodeModule';
import MarquerFinJournee from '../components/MarquerFinJournee';



import PersonnelManagementModule from '../components/shared/PersonnelManagementModule';



import EtatsFinanciersModuleFonctionnel from '../components/comptabilite/EtatsFinanciersModuleFonctionnel';



import PaieModuleFonctionnel from '../components/comptabilite/PaieModuleFonctionnel';



import { TaskManagementModule } from '../components/rh';
import MaPerformance from '../components/rh/MaPerformance';
import PreuvesPanel from '../components/shared/PreuvesPanel';
import ObjectifsEmployesModule from '../components/shared/ObjectifsEmployesModule';
import MesDemandesPermission from '../components/employe/MesDemandesPermission';


import { ComptabiliteModule } from '../components/comptabilite';



import useDeptDashboard from '../hooks/useDeptDashboard';
import TaskToggleWithPreuve from '../components/shared/TaskToggleWithPreuve';



import api from '../services/api';



import './DashboardComptabilitePage.css';







function Pbar({ pct, color }) {



  const c = color || (pct >= 70 ? '#4caf50' : pct >= 40 ? '#ff9800' : '#ef5350');



  return (



    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



      <div style={{ flex: 1, height: 6, background: 'rgba(255,255,255,0.1)', borderRadius: 99, overflow: 'hidden' }}>



        <div style={{ width: `${pct}%`, height: '100%', background: c, transition: 'width 0.3s' }} />



      </div>



      <span style={{ fontSize: 10, color: '#778', width: 32, textAlign: 'right' }}>{pct}%</span>



    </div>



  );



}







function ScoreChip({ score }) {



  const c = score >= 8 ? '#66bb6a' : score >= 6 ? '#C9A84C' : '#ef8080';



  return (



    <div style={{ width: 42, height: 42, borderRadius: '50%', border: `2px solid ${c}`, background: c + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Cormorant Garamond,serif', fontSize: 18, fontWeight: 700, color: c }}>



      {score}



    </div>



  );



}







function Badge({ variant = 'gold', children }) {



  const colors = {



    gold: { background: 'rgba(201,168,76,0.15)', color: '#C9A84C' },



    green: { background: 'rgba(76,175,80,0.15)', color: '#66bb6a' },



    red: { background: 'rgba(239,83,80,0.15)', color: '#ef8080' },



    blue: { background: 'rgba(66,165,245,0.15)', color: '#64b5f6' },



    orange: { background: 'rgba(255,152,0,0.15)', color: '#ffb74d' },



    purple: { background: 'rgba(171,71,188,0.15)', color: '#ab47bc' },



  };



  const s = colors[variant] || colors.gold;



  return <span style={{ ...s, fontSize: 10, padding: '4px 10px', borderRadius: 999, fontWeight: 600, whiteSpace: 'nowrap' }}>{children}</span>;



}







const btnSmall = (color) => ({



  border: `1px solid ${color}33`,



  background: `${color}18`,



  color,



  borderRadius: 8,



  padding: '6px 10px',



  fontSize: 11,



  fontWeight: 600,



  cursor: 'pointer',



});







const InputField = React.memo(({ label, name, type = 'text', opts, required, value, onChange }) => {



  return (



    <div style={{ marginBottom: 16 }}>



      <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>



        {label} {required && <span style={{ color: '#ef8080' }}>*</span>}



      </label>



      {opts



        ? <select



          style={{ width: '100%', background: '#0d1b2a', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



          value={value || ''}



          onChange={onChange}



        >



          <option value="">-- Selectionner --</option>



          {opts.map(o => <option key={o} value={o} style={{ background: '#0d1b2a' }}>{o}</option>)}



        </select>



        : <input



          type={type}



          style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



          value={value || ''}



          onChange={onChange}



          autoFocus={required && !value}



        />



      }



    </div>



  );



});







function ModalWrap({ title, onSave, onClose, children }) {



  return (



    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>



      <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 16, padding: 32, minWidth: 460, maxWidth: 560, width: '90%', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>



          <span style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>{title}</span>



          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#889', fontSize: 26, cursor: 'pointer', lineHeight: 1 }}>?</button>



        </div>



        {children}



        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 }}>



          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 20px', color: '#aaa', fontSize: 13, cursor: 'pointer' }}>Annuler</button>



          <button onClick={onSave} style={{ background: '#C9A84C', border: 'none', borderRadius: 8, padding: '10px 24px', color: '#000', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Enregistrer</button>



        </div>



      </div>



    </div>



  );



}







const Field = ({ label, name, type = 'text', opts, required, form, setForm }) => {



  const handleChange = React.useCallback((e) => {



    const newValue = e.target.value;



    setForm(prev => ({ ...prev, [name]: newValue }));



  }, [name, setForm]);







  return <InputField label={label} name={name} type={type} opts={opts} required={required} value={form[name]} onChange={handleChange} />;



};







// Composant pour afficher une tache hebdomadaire



function WeeklyTaskCard({ task, onToggle, onEdit, onDelete }) {



  const statusColors = {



    'a-faire': '#ff9800',



    'en-cours': '#42a5f5',



    'terminee': '#66bb6a',



    'bloquee': '#ef5350',



  };







  const statusLabels = {



    'a-faire': 'A faire',



    'en-cours': 'En cours',



    'terminee': 'Terminee',



    'bloquee': 'Bloquee',



  };







  return (



    <div style={{



      padding: 14,



      background: 'rgba(255,255,255,0.02)',



      borderRadius: 10,



      marginBottom: 10,



      borderLeft: `3px solid ${statusColors[task.statut] || '#ff9800'}`,



      transition: 'all 0.2s',



    }}>



      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>



        <div style={{ flex: 1 }}>



          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#fff' }}>{task.titre}</div>



          {task.description && (



            <div style={{ fontSize: 11, color: '#889', marginBottom: 6, lineHeight: 1.4 }}>{task.description}</div>



          )}



        </div>



        <div style={{ display: 'flex', gap: 6, marginLeft: 10 }}>



          <button onClick={() => onEdit(task)} style={{ background: 'none', border: 'none', color: '#C9A84C', cursor: 'pointer', fontSize: 13 }}>🔹</button>



          <button onClick={() => onDelete(task.id)} style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 13 }}>🗑️</button>



        </div>



      </div>







      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>



        <Badge variant={task.priorite === 'critique' ? 'red' : task.priorite === 'haute' ? 'orange' : task.priorite === 'basse' ? 'green' : 'blue'}>



          {task.priorite?.toUpperCase() || 'NORMALE'}



        </Badge>



        <Badge variant={task.statut === 'terminee' ? 'green' : task.statut === 'bloquee' ? 'red' : task.statut === 'en-cours' ? 'blue' : 'orange'}>



          {statusLabels[task.statut] || 'A faire'}



        </Badge>



        {task.jour && (



          <span style={{ fontSize: 10, color: '#C9A84C', background: 'rgba(201,168,76,0.1)', padding: '3px 8px', borderRadius: 999, fontWeight: 600 }}>



            🔹 {task.jour}



          </span>



        )}



        {task.duree && (



          <span style={{ fontSize: 10, color: '#ab47bc', background: 'rgba(171,71,188,0.1)', padding: '3px 8px', borderRadius: 999, fontWeight: 600 }}>



            🔹 {task.duree}h



          </span>



        )}



      </div>







      {task.statut !== 'terminee' && (



        <div style={{ marginTop: 10 }}>
          <button
            onClick={() => onToggle(task.id)}



            style={{



              background: task.statut === 'en-cours' ? 'rgba(102,187,106,0.15)' : 'rgba(66,165,245,0.15)',



              border: `1px solid ${task.statut === 'en-cours' ? 'rgba(102,187,106,0.3)' : 'rgba(66,165,245,0.3)'}`,



              borderRadius: 6,



              padding: '5px 12px',



              color: task.statut === 'en-cours' ? '#66bb6a' : '#64b5f6',



              fontSize: 11,



              cursor: 'pointer',



              fontWeight: 600,



            }}



          >



            {task.statut === 'en-cours' ? '? Marquer terminee' : '? Demarrer'}



          </button>



        </div>



      )}



    </div>



  );



}







function DashboardComptabilitePage() {
  // eslint-disable-next-line no-undef
  const navigate = useNavigate();

  const { logout: authLogout, user } = useAuth();



  const [activePage, setActivePage] = useState('vue-globale');



  const [modal, setModal] = useState(null);



  const [projets, setProjets] = useState([]);



  useEffect(() => { api.projects.getAll({ departement_id: DEPT_ID }).then(res => setProjets(res.projects || [])).catch(() => { }); }, []);



  const [form, setForm] = useState({});



  const [selectedEmploye, setSelectedEmploye] = useState(null);



  const [objectifForm, setObjectifForm] = useState({ employee_id: '', titre: '', description: '', progression: 0, deadline: '' });







  // Etat pour les taches hebdomadaires



  const [weeklyTasks, setWeeklyTasks] = useState([]);



  const [selectedWeek, setSelectedWeek] = useState(() => {



    const now = new Date();



    const startOfWeek = new Date(now);



    startOfWeek.setDate(now.getDate() - now.getDay() + 1);



    return startOfWeek.toISOString().slice(0, 10);



  });



  const [selectedEmployeForTasks, setSelectedEmployeForTasks] = useState('all');







  const DEPT_ID = user?.departement_id || user?.employee?.departement_id || 1;







  const {



    employes, setEmployes,



    tasks, setTasks,



    loading, error, refetch,



    toggleTask, deleteTask, createTask, updateTask,



    createObjectif, updateObjectif,



  } = useDeptDashboard({



    deptId: DEPT_ID,



    roleFilter: 'employe'



  });







  const handleLogout = async () => { await authLogout(); navigate('/auth', { replace: true }); };







  const openModal = useCallback((type, data = {}) => { setForm(data); setModal(type); }, []);



  const closeModal = useCallback(() => { setModal(null); setForm({}); }, []);







  const F = (props) => <Field {...props} form={form} setForm={setForm} />;







  const presents = employes.filter(e => e.present).length;



  const scoreAvg = employes.length > 0 ? Number((employes.reduce((sum, e) => sum + e.score, 0) / employes.length).toFixed(1)) : 0;



  const allObjectifs = employes.flatMap(e => e.objectifs || []);



  const objRate = allObjectifs.length > 0 ? Math.round((allObjectifs.filter(o => o.statut === 'atteint').length / allObjectifs.length) * 100) : 0;



  const alertes = employes.filter(e => !e.present || e.score < 7 || (e.objectifs || []).some(o => o.statut === 'retard'));

  const allObj = employes.flatMap(e => e.objectifs || []);

  const totalTasks = employes.reduce((sum, e) => sum + (e.assignedTasks || []).length, 0);



  // Filtrer uniquement les t?ches de l'utilisateur connect?



  // Filtrer uniquement les tâches assignées à l'utilisateur connecté
  const myTasks = tasks.filter(t =>
    t.employee_id === user?.id ||
    t.employee_id === user?.employee?.id ||
    t.assigned_to === user?.id ||
    t.assigned_to === user?.employee?.id
  );
  
  const pendingTasks = myTasks.filter(t => !t.done).length;







  // Calcul des stats hebdomadaires



  const weeklyStats = useMemo(() => {



    const tasksForWeek = weeklyTasks.filter(t => t.semaine === selectedWeek);



    const total = tasksForWeek.length;



    const terminees = tasksForWeek.filter(t => t.statut === 'terminee').length;



    const enCours = tasksForWeek.filter(t => t.statut === 'en-cours').length;



    const bloquees = tasksForWeek.filter(t => t.statut === 'bloquee').length;



    const tauxCompletion = total > 0 ? Math.round((terminees / total) * 100) : 0;



    return { total, terminees, enCours, bloquees, tauxCompletion };



  }, [weeklyTasks, selectedWeek]);







  const saveEmploye = async () => {



    if (!form.prenom || !form.nom || !form.poste) {



      alert('Veuillez remplir tous les champs obligatoires');



      return;



    }







    try {



      if (form._isEdit && form.id) {



        const employeeData = {



          prenom: form.prenom,



          nom: form.nom,



          poste: form.poste,



          departement_id: DEPT_ID,



          role: 'employe',



          filiale: form.filiale || 'FHC Groupe',



          contrat: form.contrat || 'CDI',



          heure_limite: form.heureLimite || '08:30',



          score_performance: parseFloat(form.score) || 0,



          color: form.color || '#66bb6a',



        };







        await api.employeesCRUD.update(form.id, employeeData);







        setEmployes(prev => prev.map(e => e.id === form.id



          ? {



            ...e,



            prenom: form.prenom,



            nom: form.nom,



            av: ((form.prenom[0] || '') + (form.nom[0] || '')).toUpperCase(),



            poste: form.poste,



            filiale: form.filiale || 'FHC Groupe',



            color: form.color || e.color,



            contrat: form.contrat || 'CDI',



            heureLimite: form.heureLimite || '08:30',



            score: parseFloat(form.score) || 0,



            scoreLabel: parseFloat(form.score) >= 8 ? 'Excellent' : parseFloat(form.score) >= 6 ? 'Bien' : 'A ameliorer',



            role: 'employe',



          }



          : e



        ));



      } else {



        const employeeData = {



          prenom: form.prenom,



          nom: form.nom,



          poste: form.poste,



          departement_id: DEPT_ID,



          role: 'employe',



          contrat: form.contrat || 'CDI',



          heure_limite: form.heureLimite || '08:30',



          score_performance: parseFloat(form.score) || 0,



          color: form.color || '#66bb6a',



          email: form.email || null,



          password: form.password || null,



        };







        const response = await api.completeResources.createEmployeeWithUser(employeeData);







        if (response.success) {



          const newEmp = response.employee;



          const userData = newEmp.user || {};







          const newEmploye = {



            id: newEmp.id,



            av: ((userData.prenom[0] || '') + (userData.nom[0] || '')).toUpperCase(),



            prenom: userData.prenom,



            nom: userData.nom,



            poste: userData.poste,



            dept: 'Comptabilite & Finance',



            filiale: form.filiale || 'FHC Groupe',



            color: newEmp.color || '#66bb6a',



            contrat: newEmp.contrat || 'CDI',



            entree: new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' }),



            heureLimite: newEmp.heure_limite || '08:30',



            arrivee: '?',



            present: false,



            score: newEmp.score_performance || 0,



            scoreLabel: (newEmp.score_performance || 0) >= 8 ? 'Excellent' : (newEmp.score_performance || 0) >= 6 ? 'Bien' : 'A ameliorer',



            tachesQuot: 0,



            tachesDone: 0,



            assignedTasks: [],



            objectifs: [],



            pendingTasks: [],



            role: 'employe',



            departement_id: DEPT_ID,



          };







          setEmployes(prev => [...prev, newEmploye]);







          if (response.credentials) {



            alert(`Employe cree avec succes!\n\nIdentifiants de connexion:\nEmail: ${response.credentials.email}\nMot de passe: ${response.credentials.password}\n\n${response.credentials.note}`);



          }



        }



      }







      closeModal();



    } catch (error) {



      alert('Erreur lors de la sauvegarde: ' + (error.message || 'Erreur inconnue'));



    }



  };







  const saveObjectif = async () => {



    if (!objectifForm.employee_id || !objectifForm.titre) {



      alert('Veuillez choisir un employ? et saisir un objectif.');



      return;



    }







    try {



      const payload = {



        titre: objectifForm.titre.trim(),



        description: objectifForm.description.trim(),



        progression: Number(objectifForm.progression) || 0,



        statut: Number(objectifForm.progression) >= 100 ? 'atteint' : 'en_cours',



        deadline: objectifForm.deadline || null,



      };







      await createObjectif(Number(objectifForm.employee_id), payload);



      setObjectifForm({ employee_id: '', titre: '', description: '', progression: 0, deadline: '' });



      closeModal();



      alert('Objectif ajout? avec succ?s.');



    } catch (error) {



      alert('Erreur lors de l\'ajout de l\'objectif : ' + (error.message || 'Erreur inconnue'));



    }



  };







  const saveTask = async () => {



    if (!form.text) {



      alert("Veuillez saisir l'intitule de la tache");



      return;



    }







    try {



      const taskData = {



        titre: form.text,



        priority: form.prio || 'normale',



        category: 'Finance',



        departement_id: DEPT_ID,



      };







      if (form._id) {



        await updateTask(form._id, taskData);



      } else {



        await createTask(taskData);



      }







      closeModal();



    } catch (error) {



      if (form._id) {



        setTasks(prev => prev.map(t => t.id === form._id ? { ...t, text: form.text, prio: form.prio || 'normale' } : t));



      } else {



        setTasks(prev => [...prev, {



          id: Date.now(),



          text: form.text,



          done: false,



          prio: form.prio || 'normale',



          date: new Date().toISOString().slice(0, 10)



        }]);



      }



      closeModal();



      alert('Tache sauvegardee localement (erreur de connexion au serveur)');



    }



  };







  // Fonction pour sauvegarder une tache hebdomadaire



  const saveWeeklyTask = async () => {



    if (!form.titre || !form.employeId) {



      alert('Veuillez remplir le titre et selectionner un employe');



      return;



    }







    try {



      const taskData = {



        id: form._id || Date.now(),



        titre: form.titre,



        description: form.description || '',



        employeId: parseInt(form.employeId),



        semaine: selectedWeek,



        jour: form.jour || 'Lundi',



        priorite: form.priorite || 'normale',



        duree: form.duree || '',



        statut: form.statut || 'a-faire',



        departement_id: DEPT_ID,



      };







      if (form._id) {



        setWeeklyTasks(prev => prev.map(t => t.id === form._id ? { ...t, ...taskData } : t));



      } else {



        setWeeklyTasks(prev => [...prev, taskData]);



      }







      closeModal();



    } catch (error) {



      alert('Erreur lors de la sauvegarde: ' + (error.message || 'Erreur inconnue'));



    }



  };







  // Fonction pour basculer le statut d'une tache hebdomadaire



  const toggleWeeklyTask = (taskId) => {



    setWeeklyTasks(prev => prev.map(t => {



      if (t.id === taskId) {



        const nextStatus = t.statut === 'a-faire' ? 'en-cours' : t.statut === 'en-cours' ? 'terminee' : 'a-faire';



        return { ...t, statut: nextStatus };



      }



      return t;



    }));



  };







  // Fonction pour supprimer une tache hebdomadaire



  const deleteWeeklyTask = (taskId) => {



    if (window.confirm('Etes-vous sur de vouloir supprimer cette tache ?')) {



      setWeeklyTasks(prev => prev.filter(t => t.id !== taskId));



    }



  };







  // Fonction pour obtenir les dates de la semaine



  const getWeekDates = (weekStart) => {



    const start = new Date(weekStart);



    const days = [];



    const dayNames = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];



    for (let i = 0; i < 7; i++) {



      const d = new Date(start);



      d.setDate(start.getDate() + i);



      days.push({



        name: dayNames[d.getDay()],



        date: d.toISOString().slice(0, 10),



        short: dayNames[d.getDay()].substring(0, 3),



      });



    }



    return days;



  };







  // Fonction pour naviguer entre les semaines



  const navigateWeek = (direction) => {



    const current = new Date(selectedWeek);



    current.setDate(current.getDate() + (direction * 7));



    setSelectedWeek(current.toISOString().slice(0, 10));



  };







  const renderModule = () => {



    switch (activePage) {



      case 'agenda': return <AgendaModuleFonctionnel />;



      case 'pointage': return <GenerationCodeModule />;



      case 'comptabilite': return <ComptabiliteModule />;



      case 'gestion-taches': return <><PreuvesPanel tasks={tasks} employes={employes} /><TaskManagementModule employes={employes} setEmployes={setEmployes} /></>;



      case 'etats-financiers': return <EtatsFinanciersModuleFonctionnel />;



      case 'paie': return <PaieModuleFonctionnel readOnly={true} />;



      case 'rapports': return <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}><h3>Rapports</h3><p>Disponible prochainement.</p></div>;



      default: return null;



    }



  };







  // Filtrer les taches hebdomadaires



  const filteredWeeklyTasks = useMemo(() => {



    let filtered = weeklyTasks.filter(t => t.semaine === selectedWeek);



    if (selectedEmployeForTasks !== 'all') {



      filtered = filtered.filter(t => t.employeId === parseInt(selectedEmployeForTasks));



    }



    return filtered;



  }, [weeklyTasks, selectedWeek, selectedEmployeForTasks]);







  // Grouper les taches par employe



  const tasksByEmploye = useMemo(() => {



    const grouped = {};



    employes.forEach(emp => {



      grouped[emp.id] = {



        employe: emp,



        tasks: filteredWeeklyTasks.filter(t => t.employeId === emp.id),



      };



    });



    return grouped;



  }, [employes, filteredWeeklyTasks]);







  const weekDays = getWeekDates(selectedWeek);



  const weekLabel = `${weekDays[0].date} au ${weekDays[6].date}`;







  return (



    <MainLayout>



      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: '#060d18', color: '#fff' }}>







        {/* TOPBAR */}



        <div style={{ height: 58, background: '#0a1520', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', flexShrink: 0 }}>



          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



            <div style={{ width: 38, height: 38, borderRadius: 10, background: 'linear-gradient(135deg,#C9A84C,#8a6028)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>🔹</div>



            <div>



              <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 20, fontWeight: 600 }}>FHC Groupe SARL</div>



              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)' }}>Dashboard ? Chef Comptabilite & Finance</div>



            </div>



          </div>



          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>



            <div style={{ fontSize: 11, color: '#445', background: '#162535', padding: '6px 14px', borderRadius: 20, border: '1px solid rgba(255,255,255,0.07)' }}>



              {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}



            </div>



            <button onClick={refetch} style={{ background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 7, padding: '6px 12px', color: '#aaa', fontSize: 11, cursor: 'pointer' }}>?</button>



            <div className="tavatar" style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg,#66bb6a,#388e3c)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700 }}>CF</div>



            <button onClick={handleLogout} style={{ background: 'rgba(239,83,80,0.1)', border: '1px solid rgba(239,83,80,0.3)', borderRadius: 7, padding: '6px 14px', color: '#ef8080', fontSize: 11, cursor: 'pointer' }}>🔹 Deconnexion</button>



          </div>



        </div>







        {/* TABS */}



        <div style={{ background: '#0a1520', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', gap: 2, padding: '0 24px', flexShrink: 0, overflowX: 'auto' }}>



          {[

            { id: 'vue-globale', icon: '🔹', label: 'Vue Globale' },

            { id: 'mon-equipe', icon: '🔹', label: 'Mon Equipe', badge: employes.length },

            { id: 'ma-performance', icon: '⭐', label: 'Ma Performance' },

            { id: 'performances', icon: '📊', label: 'Performances' },

            { id: 'objectifs', icon: '🎯', label: 'Objectifs', badge: allObj.filter(o => o.statut === 'atteint').length || null },



            { id: 'taches-quotidiennes', icon: '?', label: 'Taches Quotidiennes' },



            { id: 'taches-hebdomadaires', icon: '🔹', label: 'Taches Hebdomadaires', badge: weeklyStats.total || null },



            { id: 'mes-taches', icon: '🔹', label: 'Mes Taches', badge: pendingTasks },
            { id: 'permissions', icon: '📝', label: 'Mes Permissions' },
            { id: 'alertes', icon: '🔹', label: 'Alertes', badge: alertes.length },



            { id: 'projets', icon: '🔹', label: 'Projets', badge: projets.length > 0 ? projets.length : null },



            { id: 'agenda', icon: '🔹', label: 'Agenda' },



            { id: 'pointage', icon: '🔹', label: 'Pointage' },



            { id: 'comptabilite', icon: '🔹', label: 'Comptabilite' },



            { id: 'gestion-taches', icon: '🔹', label: 'Gestion Taches', badge: totalTasks || null },



            { id: 'etats-financiers', icon: '🔹', label: 'Etats Financiers' },



            { id: 'paie', icon: '🔹', label: 'Paie' },



            { id: 'rapports', icon: '🔹', label: 'Rapports' },

            { id: 'documents', icon: '📁', label: 'Documents' },



          ].map(tab => (



            <div key={tab.id} onClick={() => setActivePage(tab.id)}



              style={{ padding: '11px 16px', fontSize: 12, color: activePage === tab.id ? '#C9A84C' : '#667', cursor: 'pointer', borderBottom: activePage === tab.id ? '2px solid #C9A84C' : '2px solid transparent', transition: 'all 0.15s', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 6 }}>



              {tab.icon} {tab.label}



              {tab.badge > 0 && <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 99, background: activePage === tab.id ? 'rgba(201,168,76,0.3)' : 'rgba(255,255,255,0.1)', color: activePage === tab.id ? '#C9A84C' : '#889' }}>{tab.badge}</span>}



            </div>



          ))}



        </div>







        {/* CONTENT */}



        <div style={{ flex: 1, overflow: 'auto', background: '#060d18' }}>



          <div style={{ padding: '20px 24px' }}>







            {loading && <div style={{ padding: 40, textAlign: 'center', color: '#C9A84C', fontSize: 14 }}>Chargement des donnees?</div>}



            {error && !loading && <div style={{ marginBottom: 16, padding: '10px 16px', background: 'rgba(239,83,80,.1)', border: '1px solid rgba(239,83,80,.3)', borderRadius: 8, fontSize: 12, color: '#ef8080' }}>🔹 {error}</div>}







            {/* VUE GLOBALE */}



            {activePage === 'vue-globale' && (



              <div>



                <div style={{ marginBottom: 24 }}>



                  <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>🔹 Vue Globale ? Comptabilite & Finance</h2>



                  <p style={{ fontSize: 13, color: '#667' }}>{employes.length} collaborateurs ? Donnees temps reel</p>



                </div>







                <PointageModule currentUser={{ nom: 'Chef Comptabilite' }} />

                <MarquerFinJournee onSuccess={() => {
                  console.log('Fin de journée enregistrée - Dashboard Comptabilité');
                }} />





                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginTop: 20, marginBottom: 24 }}>



                  {[



                    { icon: '🔹', label: 'Collaborateurs', value: employes.length, color: '#42a5f5', info: `${presents}/${employes.length} presents` },



                    { icon: '?', label: 'Score Moyen', value: scoreAvg + '/10', color: '#C9A84C', info: scoreAvg >= 8 ? 'Excellent' : scoreAvg >= 6 ? 'Bien' : 'A ameliorer' },



                    { icon: '🔹', label: 'Objectifs Atteints', value: objRate + '%', color: '#66bb6a', info: `${allObjectifs.filter(o => o.statut === 'atteint').length}/${allObjectifs.length} objectifs` },



                    { icon: '🔹', label: 'Alertes Actives', value: alertes.length, color: alertes.length > 0 ? '#ef5350' : '#66bb6a', info: alertes.length > 0 ? 'Necessite attention' : 'RAS' },



                    { icon: '🔹', label: 'Taches Assignees', value: totalTasks, color: '#ab47bc', info: `${pendingTasks} en attente` },



                  ].map((kpi, i) => (



                    <div key={i} style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20, position: 'relative', overflow: 'hidden' }}>



                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: kpi.color }} />



                      <div style={{ fontSize: 24, marginBottom: 12 }}>{kpi.icon}</div>



                      <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 32, fontWeight: 700, color: kpi.color, marginBottom: 6, lineHeight: 1 }}>{kpi.value}</div>



                      <div style={{ fontSize: 12, color: '#aaa', marginBottom: 4 }}>{kpi.label}</div>



                      <div style={{ fontSize: 10, color: '#667' }}>{kpi.info}</div>



                    </div>



                  ))}



                </div>







                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20, marginBottom: 20 }}>



                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>



                    <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>🔹 Equipe Comptabilite</h3>



                    <button onClick={() => setActivePage('mon-equipe')} style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: 8, padding: '6px 14px', color: '#C9A84C', fontSize: 11, cursor: 'pointer' }}>Voir details ?</button>



                  </div>



                  {employes.length === 0



                    ? <div style={{ textAlign: 'center', padding: '20px 0', color: '#445', fontSize: 12 }}>Aucun collaborateur dans ce departement.</div>



                    : <div style={{ display: 'grid', gap: 12 }}>



                      {employes.map(emp => {



                        const pct = emp.tachesQuot > 0 ? Math.round((emp.tachesDone / emp.tachesQuot) * 100) : 0;



                        return (



                          <div key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 14, background: 'rgba(255,255,255,0.02)', borderRadius: 10, cursor: 'pointer' }} onClick={() => setSelectedEmploye(emp)}>



                            <div style={{ width: 44, height: 44, borderRadius: '50%', background: emp.color + '22', color: emp.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, border: `2px solid ${emp.color}44` }}>{emp.av}</div>



                            <div style={{ flex: 1 }}>



                              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{emp.prenom} {emp.nom}</div>



                              <div style={{ fontSize: 11, color: '#889' }}>{emp.poste} ? {emp.filiale}</div>



                            </div>



                            <div style={{ textAlign: 'center', minWidth: 80 }}>



                              <div style={{ fontSize: 10, color: '#667', marginBottom: 2 }}>Taches</div>



                              <div style={{ fontSize: 14, fontWeight: 600, color: pct >= 70 ? '#66bb6a' : '#ff9800' }}>{emp.tachesDone}/{emp.tachesQuot}</div>



                            </div>



                            <ScoreChip score={emp.score} />



                            <Badge variant={emp.present ? 'green' : 'red'}>{emp.present ? '? Present' : '? Absent'}</Badge>



                          </div>



                        );



                      })}



                    </div>



                  }



                </div>







                {alertes.length > 0 && (



                  <div style={{ background: '#2d1515', border: '1px solid rgba(239,83,80,0.3)', borderRadius: 14, padding: 20 }}>



                    <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: '#ef8080' }}>🔹 Alertes ({alertes.length})</h3>



                    {alertes.map(emp => (



                      <div key={emp.id} style={{ padding: 12, background: 'rgba(239,83,80,0.1)', borderRadius: 8, fontSize: 13, marginBottom: 8 }}>



                        <strong>{emp.prenom} {emp.nom}</strong> ?{' '}



                        {!emp.present && <span>Absent ? </span>}



                        {emp.score < 7 && <span>Score faible ({emp.score}/10) ? </span>}



                        {(emp.objectifs || []).some(o => o.statut === 'retard') && <span>Objectifs en retard</span>}



                      </div>



                    ))}



                  </div>



                )}



              </div>



            )}







            {/* MON EQUIPE */}



            {activePage === 'mon-equipe' && (



              <PersonnelManagementModule employes={employes} setEmployes={setEmployes} departmentName="Comptabilite & Finance" heureLimite="08:30" />



            )}

            {/* MA PERFORMANCE */}

            {activePage === 'ma-performance' && (

              <div>

                <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>⭐ Ma Performance</h2>

                <MaPerformance />

              </div>

            )}

            {/* PERFORMANCES */}

            {activePage === 'performances' && (



              <div>



                <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>? Performances & Scores</h2>



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20, marginBottom: 20 }}>



                  <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>🔹 Classement par Score</h3>



                  {[...employes].sort((a, b) => b.score - a.score).map((emp, index) => (



                    <div key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 16, background: 'rgba(255,255,255,0.02)', borderRadius: 10, marginBottom: 8, border: index < 3 ? `1px solid ${emp.color}44` : '1px solid rgba(255,255,255,0.05)' }}>



                      <div style={{ width: 36, height: 36, borderRadius: '50%', background: index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : 'rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, color: index < 3 ? '#000' : '#667' }}>{index + 1}</div>



                      <div style={{ width: 48, height: 48, borderRadius: '50%', background: emp.color + '22', color: emp.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, border: `2px solid ${emp.color}44` }}>{emp.av}</div>



                      <div style={{ flex: 1 }}>



                        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{emp.prenom} {emp.nom}</div>



                        <div style={{ fontSize: 11, color: '#889' }}>{emp.poste}</div>



                      </div>



                      <ScoreChip score={emp.score} />



                      <Badge variant={emp.score >= 8 ? 'green' : emp.score >= 6 ? 'gold' : 'red'}>{emp.scoreLabel}</Badge>



                    </div>



                  ))}



                </div>



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20 }}>



                  <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>? Taux d'Accomplissement</h3>



                  {employes.map(emp => {



                    const pct = emp.tachesQuot > 0 ? Math.round((emp.tachesDone / emp.tachesQuot) * 100) : 0;



                    return (



                      <div key={emp.id} style={{ padding: '12px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>



                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>



                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



                            <div style={{ width: 32, height: 32, borderRadius: '50%', background: emp.color + '22', color: emp.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{emp.av}</div>



                            <span style={{ fontSize: 13, fontWeight: 500 }}>{emp.prenom} {emp.nom}</span>



                          </div>



                          <div style={{ fontSize: 13, color: '#889' }}>{emp.tachesDone}/{emp.tachesQuot} taches</div>



                        </div>



                        <Pbar pct={pct} />



                      </div>



                    );



                  })}



                </div>



              </div>



            )}







            {/* OBJECTIFS */}



            {activePage === 'objectifs' && (

              <div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>

                  <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 0 }}>🎯 Objectifs de l'Équipe</h2>

                </div>

                <ObjectifsEmployesModule 
                  employes={employes} 
                  onRefresh={refetch} 
                  isChef={true} 
                />

              </div>

            )}







            {/* TACHES QUOTIDIENNES */}



            {activePage === 'taches-quotidiennes' && (



              <div>



                <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>? Taches Quotidiennes</h2>



                {employes.map(emp => {



                  const pct = emp.tachesQuot > 0 ? Math.round((emp.tachesDone / emp.tachesQuot) * 100) : 0;



                  return (



                    <div key={emp.id} style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20, marginBottom: 16 }}>



                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>



                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



                          <div style={{ width: 48, height: 48, borderRadius: '50%', background: emp.color + '22', color: emp.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, border: `2px solid ${emp.color}44` }}>{emp.av}</div>



                          <div>



                            <div style={{ fontSize: 16, fontWeight: 600 }}>{emp.prenom} {emp.nom}</div>



                            <div style={{ fontSize: 12, color: '#889' }}>{emp.tachesDone}/{emp.tachesQuot} taches aujourd'hui</div>



                          </div>



                        </div>



                        <div style={{ fontSize: 28, fontWeight: 700, color: pct >= 70 ? '#66bb6a' : pct >= 40 ? '#ff9800' : '#ef5350' }}>{pct}%</div>



                      </div>



                      <Pbar pct={pct} />



                      {(emp.pendingTasks || []).length > 0 && (



                        <div style={{ marginTop: 16 }}>



                          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: '#C9A84C' }}>🔹 En attente ({(emp.pendingTasks || []).length})</div>



                          {(emp.pendingTasks || []).map((task, idx) => (



                            <div key={idx} style={{ padding: 10, background: 'rgba(255,255,255,0.02)', borderRadius: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, borderLeft: `3px solid ${task.prio === 'urgente' ? '#ef5350' : task.prio === 'haute' ? '#ff9800' : '#42a5f5'}` }}>



                              <span style={{ fontSize: 12 }}>{task.titre}</span>



                              <Badge variant={task.prio === 'urgente' ? 'red' : task.prio === 'haute' ? 'orange' : 'blue'}>{task.prio}</Badge>



                            </div>



                          ))}



                        </div>



                      )}



                    </div>



                  );



                })}



              </div>



            )}







            {/* TACHES HEBDOMADAIRES ? NOUVELLE SECTION */}



            {activePage === 'taches-hebdomadaires' && (



              <div>



                {/* Header */}



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>



                  <div>



                    <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>🔹 Taches Hebdomadaires</h2>



                    <p style={{ fontSize: 13, color: '#667' }}>Planification et suivi des taches de la semaine</p>



                  </div>



                  <button



                    onClick={() => openModal('weekly-task', { priorite: 'normale', jour: 'Lundi', statut: 'a-faire' })}



                    style={{ background: '#C9A84C', border: 'none', borderRadius: 8, padding: '10px 20px', color: '#000', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}



                  >



                    + Nouvelle tache



                  </button>



                </div>







                {/* Barre de navigation semaine + filtres */}



                <div style={{



                  background: '#111f30',



                  border: '1px solid rgba(255,255,255,0.06)',



                  borderRadius: 14,



                  padding: 20,



                  marginBottom: 20,



                  display: 'flex',



                  alignItems: 'center',



                  gap: 16,



                  flexWrap: 'wrap',



                }}>



                  {/* Navigation semaine */}



                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                    <button



                      onClick={() => navigateWeek(-1)}



                      style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 12px', color: '#aaa', fontSize: 14, cursor: 'pointer' }}



                    >



                      ?



                    </button>



                    <div style={{ textAlign: 'center', minWidth: 180 }}>



                      <div style={{ fontSize: 14, fontWeight: 600, color: '#C9A84C' }}>Semaine du {weekLabel}</div>



                      <div style={{ fontSize: 10, color: '#667', marginTop: 2 }}>



                        {weekDays.map((d, i) => (



                          <span key={i} style={{ margin: '0 3px' }}>



                            <span style={{ color: d.name === new Date().toLocaleDateString('fr-FR', { weekday: 'long' }) ? '#C9A84C' : '#667' }}>{d.short}</span>



                          </span>



                        ))}



                      </div>



                    </div>



                    <button



                      onClick={() => navigateWeek(1)}



                      style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 12px', color: '#aaa', fontSize: 14, cursor: 'pointer' }}



                    >



                      ?



                    </button>



                  </div>







                  <div style={{ width: 1, height: 32, background: 'rgba(255,255,255,0.1)' }} />







                  {/* Filtre employe */}



                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                    <span style={{ fontSize: 12, color: '#889' }}>🔹 Employe:</span>



                    <select



                      value={selectedEmployeForTasks}



                      onChange={(e) => setSelectedEmployeForTasks(e.target.value)}



                      style={{ background: '#0d1b2a', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '8px 12px', color: '#fff', fontSize: 12, outline: 'none', minWidth: 160 }}



                    >



                      <option value="all">Tous les employes</option>



                      {employes.map(emp => (



                        <option key={emp.id} value={emp.id}>{emp.prenom} {emp.nom}</option>



                      ))}



                    </select>



                  </div>







                  <div style={{ flex: 1 }} />







                  {/* KPIs rapides */}



                  <div style={{ display: 'flex', gap: 12 }}>



                    <div style={{ textAlign: 'center', padding: '6px 12px', background: 'rgba(255,255,255,0.03)', borderRadius: 8 }}>



                      <div style={{ fontSize: 16, fontWeight: 700, color: '#C9A84C' }}>{weeklyStats.total}</div>



                      <div style={{ fontSize: 9, color: '#667' }}>Total</div>



                    </div>



                    <div style={{ textAlign: 'center', padding: '6px 12px', background: 'rgba(102,187,106,0.1)', borderRadius: 8 }}>



                      <div style={{ fontSize: 16, fontWeight: 700, color: '#66bb6a' }}>{weeklyStats.terminees}</div>



                      <div style={{ fontSize: 9, color: '#667' }}>Terminees</div>



                    </div>



                    <div style={{ textAlign: 'center', padding: '6px 12px', background: 'rgba(66,165,245,0.1)', borderRadius: 8 }}>



                      <div style={{ fontSize: 16, fontWeight: 700, color: '#42a5f5' }}>{weeklyStats.enCours}</div>



                      <div style={{ fontSize: 9, color: '#667' }}>En cours</div>



                    </div>



                    <div style={{ textAlign: 'center', padding: '6px 12px', background: 'rgba(239,83,80,0.1)', borderRadius: 8 }}>



                      <div style={{ fontSize: 16, fontWeight: 700, color: '#ef8080' }}>{weeklyStats.bloquees}</div>



                      <div style={{ fontSize: 9, color: '#667' }}>Bloquees</div>



                    </div>



                  </div>



                </div>







                {/* Progression globale */}



                {weeklyStats.total > 0 && (



                  <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 16, marginBottom: 20 }}>



                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>



                      <span style={{ fontSize: 12, fontWeight: 600, color: '#C9A84C' }}>🔹 Progression globale de la semaine</span>



                      <span style={{ fontSize: 14, fontWeight: 700, color: weeklyStats.tauxCompletion >= 70 ? '#66bb6a' : weeklyStats.tauxCompletion >= 40 ? '#ff9800' : '#ef8080' }}>{weeklyStats.tauxCompletion}%</span>



                    </div>



                    <Pbar pct={weeklyStats.tauxCompletion} />



                  </div>



                )}







                {/* Vue par employe */}



                {employes.length === 0 ? (



                  <div style={{ textAlign: 'center', padding: '40px 0', color: '#445', fontSize: 14 }}>



                    <div style={{ fontSize: 48, marginBottom: 12 }}>🔹</div>



                    <div>Aucun employe dans ce departement.</div>



                  </div>



                ) : (



                  <div style={{ display: 'grid', gap: 16 }}>



                    {Object.values(tasksByEmploye)



                      .filter(group => selectedEmployeForTasks === 'all' || group.employe.id === parseInt(selectedEmployeForTasks))



                      .map(({ employe, tasks: empTasks }) => {



                        const empPct = empTasks.length > 0 ? Math.round((empTasks.filter(t => t.statut === 'terminee').length / empTasks.length) * 100) : 0;







                        return (



                          <div key={employe.id} style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20 }}>



                            {/* Header employe */}



                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>



                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



                                <div style={{ width: 44, height: 44, borderRadius: '50%', background: employe.color + '22', color: employe.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, border: `2px solid ${employe.color}44` }}>{employe.av}</div>



                                <div>



                                  <div style={{ fontSize: 16, fontWeight: 600 }}>{employe.prenom} {employe.nom}</div>



                                  <div style={{ fontSize: 12, color: '#889' }}>{employe.poste}</div>



                                </div>



                              </div>



                              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



                                <div style={{ textAlign: 'right' }}>



                                  <div style={{ fontSize: 20, fontWeight: 700, color: empPct >= 70 ? '#66bb6a' : empPct >= 40 ? '#ff9800' : '#ef8080' }}>{empPct}%</div>



                                  <div style={{ fontSize: 10, color: '#667' }}>{empTasks.filter(t => t.statut === 'terminee').length}/{empTasks.length} terminees</div>



                                </div>



                                <button



                                  onClick={() => openModal('weekly-task', { employeId: employe.id, priorite: 'normale', jour: 'Lundi', statut: 'a-faire' })}



                                  style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: 8, padding: '6px 12px', color: '#C9A84C', fontSize: 11, cursor: 'pointer' }}



                                >



                                  + Ajouter



                                </button>



                              </div>



                            </div>







                            {/* Barre de progression */}



                            {empTasks.length > 0 && <Pbar pct={empPct} color={employe.color} />}







                            {/* Taches par jour */}



                            <div style={{ marginTop: 16 }}>



                              {weekDays.map(day => {



                                const dayTasks = empTasks.filter(t => t.jour === day.name);



                                if (dayTasks.length === 0) return null;







                                return (



                                  <div key={day.name} style={{ marginBottom: 12 }}>



                                    <div style={{



                                      fontSize: 11,



                                      fontWeight: 600,



                                      color: day.date === new Date().toISOString().slice(0, 10) ? '#C9A84C' : '#667',



                                      marginBottom: 8,



                                      padding: '4px 10px',



                                      background: day.date === new Date().toISOString().slice(0, 10) ? 'rgba(201,168,76,0.1)' : 'transparent',



                                      borderRadius: 6,



                                      display: 'inline-block',



                                    }}>



                                      {day.name} {day.date === new Date().toISOString().slice(0, 10) && "(Aujourd'hui)"}



                                    </div>



                                    {dayTasks.map(task => (



                                      <WeeklyTaskCard



                                        key={task.id}



                                        task={task}



                                        onToggle={toggleWeeklyTask}



                                        onEdit={(t) => openModal('weekly-task', { ...t, _id: t.id, employeId: t.employeId })}



                                        onDelete={deleteWeeklyTask}



                                      />



                                    ))}



                                  </div>



                                );



                              })}







                              {/* Taches sans jour specifique */}



                              {empTasks.filter(t => !t.jour || !weekDays.some(d => d.name === t.jour)).length > 0 && (



                                <div style={{ marginTop: 12 }}>



                                  <div style={{ fontSize: 11, fontWeight: 600, color: '#667', marginBottom: 8 }}>🔹 Sans jour specifique</div>



                                  {empTasks



                                    .filter(t => !t.jour || !weekDays.some(d => d.name === t.jour))



                                    .map(task => (



                                      <WeeklyTaskCard



                                        key={task.id}



                                        task={task}



                                        onToggle={toggleWeeklyTask}



                                        onEdit={(t) => openModal('weekly-task', { ...t, _id: t.id, employeId: t.employeId })}



                                        onDelete={deleteWeeklyTask}



                                      />



                                    ))}



                                </div>



                              )}







                              {empTasks.length === 0 && (



                                <div style={{ padding: 16, textAlign: 'center', color: '#445', fontSize: 12 }}>



                                  Aucune tache assignee cette semaine.



                                </div>



                              )}



                            </div>



                          </div>



                        );



                      })}



                  </div>



                )}



              </div>



            )}







            {/* MES TACHES */}



            {activePage === 'mes-taches' && (



              <div>



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>



                  <div>



                    <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>🔹 Mes Taches</h2>



                    <p style={{ fontSize: 12, color: '#667' }}>



                      {myTasks.filter(t => !t.done).length} en attente / {myTasks.length} total



                    </p>



                  </div>



                  <button onClick={() => openModal('tache', { prio: 'normale' })} style={{ background: '#C9A84C', border: 'none', borderRadius: 8, padding: '10px 20px', color: '#000', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}>+ Ajouter</button>



                </div>



                <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: 20 }}>



                  {(() => {



                    // Utiliser myTasks déjà filtré au niveau global (pas de re-filtrage nécessaire)







                    return myTasks.length === 0



                      ? <div style={{ textAlign: 'center', padding: '20px 0', color: '#445', fontSize: 12 }}>Aucune tache assignee.</div>



                      : myTasks.map(t => (



                        <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>



                          <TaskToggleWithPreuve task={t} onToggle={toggleTask} onToggleWithPreuve={async (id) => { await toggleTask(id); }} />



                          <span style={{ flex: 1, fontSize: 13, color: t.done ? '#445' : '#ccc', textDecoration: t.done ? 'line-through' : 'none' }}>{t.text || t.titre}</span>



                          <Badge variant={t.prio === 'urgente' || t.priority === 'urgente' ? 'red' : (t.prio === 'haute' || t.priority === 'haute') ? 'orange' : 'blue'}>



                            {t.prio || t.priority || 'normale'}



                          </Badge>



                          <button onClick={() => openModal('tache', { _id: t.id, text: t.text || t.titre, prio: t.prio || t.priority })} style={{ background: 'none', border: 'none', color: '#667', cursor: 'pointer', fontSize: 13 }}>🔹</button>



                          <button onClick={() => deleteTask(t.id)} style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 13 }}>🗑️</button>



                        </div>



                      ));



                  })()}



                </div>



              </div>



            )}

            {/* PERMISSIONS */}

            {activePage === 'permissions' && (
              <div>
                <div style={{ marginBottom: 24 }}>
                  <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>📝 Mes Demandes de Permission</h2>
                  <p style={{ fontSize: 12, color: '#667' }}>Gérez vos demandes de congés, absences et permissions</p>
                </div>
                <MesDemandesPermission />
              </div>
            )}








            {/* ALERTES */}



            {activePage === 'alertes' && (



              <div>



                <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 20 }}>🔹 Alertes & Notifications</h2>



                {alertes.length === 0



                  ? <div style={{ background: '#1d3a1d', border: '1px solid rgba(102,187,106,0.3)', borderRadius: 14, padding: 40, textAlign: 'center' }}>



                    <div style={{ fontSize: 48, marginBottom: 12 }}>?</div>



                    <div style={{ fontSize: 18, fontWeight: 600, color: '#66bb6a' }}>Aucune alerte active</div>



                  </div>



                  : <div style={{ display: 'grid', gap: 16 }}>



                    {alertes.map(emp => (



                      <div key={emp.id} style={{ background: '#2d1515', border: '1px solid rgba(239,83,80,0.3)', borderRadius: 14, padding: 20 }}>



                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>



                          <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#ef535022', color: '#ef8080', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700 }}>{emp.av}</div>



                          <div style={{ flex: 1 }}>



                            <div style={{ fontSize: 16, fontWeight: 600 }}>{emp.prenom} {emp.nom}</div>



                            <div style={{ fontSize: 12, color: '#889' }}>{emp.poste}</div>



                          </div>



                          <Badge variant="red">🔹 Alerte</Badge>



                        </div>



                        {!emp.present && <div style={{ padding: 12, background: 'rgba(239,83,80,0.15)', borderRadius: 8, fontSize: 13, marginBottom: 8, borderLeft: '3px solid #ef5350' }}><strong>? Absent</strong></div>}



                        {emp.score < 7 && <div style={{ padding: 12, background: 'rgba(239,83,80,0.15)', borderRadius: 8, fontSize: 13, marginBottom: 8, borderLeft: '3px solid #ef5350' }}><strong>🔹 Score insuffisant</strong> ? {emp.score}/10</div>}



                        {(emp.objectifs || []).some(o => o.statut === 'retard') && <div style={{ padding: 12, background: 'rgba(239,83,80,0.15)', borderRadius: 8, fontSize: 13, borderLeft: '3px solid #ef5350' }}><strong>🔹 Objectifs en retard</strong></div>}



                      </div>



                    ))}



                  </div>



                }



              </div>



            )}







            {/* MODULES EXTERNES */}



            {activePage === 'projets' && (



              <div>



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>



                  <div style={{ fontSize: 16, fontWeight: 700 }}>🔹 Projets du d?partement</div>



                  <div style={{ fontSize: 11, color: '#94a3b8' }}>{projets.length} projet{projets.length !== 1 ? 's' : ''}</div>



                </div>



                {projets.length === 0 ? (



                  <div style={{ textAlign: 'center', padding: 40, color: '#445' }}>Aucun projet assign? ? ce d?partement.</div>



                ) : projets.map(p => {



                  const sc = { en_cours: '#42a5f5', planification: '#C9A84C', production: '#ff9800', termine: '#66bb6a', annule: '#ef5350', negociation: '#ab47bc' }[p.status] || '#888';



                  const sl = { en_cours: 'En cours', planification: 'Planification', production: 'Production', termine: 'Termin?', annule: 'Annul?', negociation: 'N?gociation' }[p.status] || p.status;



                  const av = p.progress || 0;



                  return (



                    <div key={p.id} style={{ background: '#162535', borderRadius: 10, padding: 16, marginBottom: 12, border: '1px solid rgba(255,255,255,.06)' }}>



                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>



                        <div>



                          <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{p.name}</div>



                          <div style={{ fontSize: 11, color: '#667' }}>{p.filiale?.nom || '?'}{p.departement?.nom ? ' ? ' + p.departement.nom : ''}</div>



                        </div>



                        <span style={{ fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 99, background: sc + '22', color: sc }}>{sl}</span>



                      </div>



                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 }}>



                        {[['Budget', p.budget ? Number(p.budget).toLocaleString('fr-FR') + ' FCFA' : '?'], ['Deadline', p.end_date ? new Date(p.end_date).toLocaleDateString('fr-FR') : '?'], ['Chef', p.owner ? (p.owner.prenom + ' ' + (p.owner.nom || '')) : '?']].map(([l, v]) => (



                          <div key={l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '8px 10px' }}>



                            <div style={{ fontSize: 9, color: '#556', marginBottom: 3 }}>{l}</div>



                            <div style={{ fontSize: 11, fontWeight: 600, color: '#ccc' }}>{v}</div>



                          </div>



                        ))}



                      </div>



                      <div style={{ fontSize: 10, color: '#667', marginBottom: 5, display: 'flex', justifyContent: 'space-between' }}>



                        <span>Avancement</span><span style={{ fontWeight: 600 }}>{av}%</span>



                      </div>



                      <div style={{ height: 5, background: 'rgba(255,255,255,.06)', borderRadius: 99 }}>



                        <div style={{ width: av + '%', height: '100%', background: av >= 70 ? '#4caf50' : av >= 40 ? '#ff9800' : '#ef5350', borderRadius: 99 }} />



                      </div>



                    </div>



                  );



                })}



              </div>



            )}



            {['agenda', 'pointage', 'comptabilite', 'gestion-taches', 'etats-financiers', 'paie', 'rapports'].includes(activePage) && renderModule()}

            {activePage === 'documents' && (() => { navigate('/documents'); return null; })()}



          </div>



        </div>







        {/* MODAL EMPLOYE */}



        {modal === 'employe' && (



          <ModalWrap key={`employe-${form.id || 'new'}`} title={form._isEdit ? '🔹 Modifier' : '? Nouvel employe'} onSave={saveEmploye} onClose={closeModal}>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



              <F label="Prenom" name="prenom" required />



              <F label="Nom" name="nom" required />



            </div>



            <F label="Poste" name="poste" required />



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



              <F label="Email" name="email" type="email" />



              <F label="Mot de passe" name="password" type="password" />



            </div>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



              <F label="Filiale" name="filiale" opts={['FHC Groupe', 'FHC Conseil', 'FHC Technologie', 'FHC Formation', 'FHC Location']} />



              <F label="Contrat" name="contrat" opts={['CDI', 'CDD', 'Stage', 'Freelance']} />



              <F label="Score (0-10)" name="score" type="number" />



              <F label="Heure limite" name="heureLimite" type="time" />



            </div>



            <F label="Couleur (hex)" name="color" type="color" />



          </ModalWrap>



        )}







        {/* MODAL OBJECTIF */}



        {modal === 'objectif' && (



          <ModalWrap key={`objectif-${objectifForm.employee_id || 'new'}`} title="🔹 Ajouter un objectif" onSave={saveObjectif} onClose={closeModal}>



            <div style={{ display: 'grid', gap: 14 }}>



              <div>



                <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>Employ?</label>



                <select



                  value={objectifForm.employee_id}



                  onChange={(e) => setObjectifForm(prev => ({ ...prev, employee_id: e.target.value }))}



                  style={{ width: '100%', background: '#0d1b2a', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                >



                  <option value="">-- S?lectionner --</option>



                  {employes.map(emp => <option key={emp.id} value={emp.id} style={{ background: '#0d1b2a' }}>{emp.prenom} {emp.nom}</option>)}



                </select>



              </div>



              <div>



                <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>Titre de l'objectif *</label>



                <input



                  autoFocus



                  value={objectifForm.titre || ''}



                  onChange={(e) => setObjectifForm(prev => ({ ...prev, titre: e.target.value }))}



                  style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                />



              </div>



              <div>



                <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>Description</label>



                <input



                  value={objectifForm.description || ''}



                  onChange={(e) => setObjectifForm(prev => ({ ...prev, description: e.target.value }))}



                  style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                />



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



                <div>



                  <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>Progression (%)</label>



                  <input



                    type="number"



                    min="0"



                    max="100"



                    value={objectifForm.progression || 0}



                    onChange={(e) => setObjectifForm(prev => ({ ...prev, progression: Number(e.target.value) }))}



                    style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                  />



                </div>



                <div>



                  <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>Date limite</label>



                  <input



                    type="date"



                    value={objectifForm.deadline || ''}



                    onChange={(e) => setObjectifForm(prev => ({ ...prev, deadline: e.target.value }))}



                    style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                  />



                </div>



              </div>



              <div style={{ fontSize: 11, color: '#889', lineHeight: 1.5 }}>Le statut sera automatiquement mis ? "atteint" si la progression atteint 100%.</div>



            </div>



          </ModalWrap>



        )}







        {/* MODAL TACHE */}



        {modal === 'tache' && (



          <ModalWrap key={`tache-${form._id || 'new'}`} title={form._id ? 'Modifier la tache' : 'Nouvelle tache'} onSave={saveTask} onClose={closeModal}>



            <F label="Tache *" name="text" required />



            <F label="Priorite" name="prio" opts={['urgente', 'haute', 'normale']} />



          </ModalWrap>



        )}







        {/* MODAL TACHE HEBDOMADAIRE */}



        {modal === 'weekly-task' && (



          <ModalWrap key={`weekly-task-${form._id || 'new'}`} title={form._id ? '🔹 Modifier la tache hebdomadaire' : '🔹 Nouvelle tache hebdomadaire'} onSave={saveWeeklyTask} onClose={closeModal}>



            <F label="Titre *" name="titre" required />



            <F label="Description" name="description" />



            {/* Employe select - custom because opts expects string array */}



            <div style={{ marginBottom: 16 }}>



              <label style={{ fontSize: 11, color: '#889', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: 6, fontWeight: 600 }}>



                Employe * <span style={{ color: '#ef8080' }}>*</span>



              </label>



              <select



                style={{ width: '100%', background: '#0d1b2a', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none' }}



                value={form.employeId || ''}



                onChange={(e) => setForm(prev => ({ ...prev, employeId: e.target.value }))}



              >



                <option value="">-- Selectionner --</option>



                {employes.map(emp => (



                  <option key={emp.id} value={emp.id} style={{ background: '#0d1b2a' }}>



                    {emp.prenom} {emp.nom}



                  </option>



                ))}



              </select>



            </div>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



              <F label="Jour" name="jour" opts={['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']} />



              <F label="Priorite" name="priorite" opts={['basse', 'normale', 'haute', 'critique']} />



            </div>



            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>



              <F label="Duree estimee (heures)" name="duree" type="number" />



              <F label="Statut" name="statut" opts={['a-faire', 'en-cours', 'terminee', 'bloquee']} />



            </div>



          </ModalWrap>



        )}







        {/* MODAL DETAIL EMPLOYE */}



        {selectedEmploye && (



          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedEmploye(null)}>



            <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 16, padding: 32, width: '90%', maxWidth: 700, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>



                <div style={{ display: 'flex', gap: 16 }}>



                  <div style={{ width: 72, height: 72, borderRadius: '50%', background: selectedEmploye.color + '22', color: selectedEmploye.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, border: `3px solid ${selectedEmploye.color}44` }}>{selectedEmploye.av}</div>



                  <div>



                    <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>{selectedEmploye.prenom} {selectedEmploye.nom}</div>



                    <div style={{ fontSize: 14, color: '#889', marginBottom: 8 }}>{selectedEmploye.poste}</div>



                    <div style={{ display: 'flex', gap: 8 }}>



                      <Badge variant={selectedEmploye.present ? 'green' : 'red'}>{selectedEmploye.present ? '? Present' : '? Absent'}</Badge>



                      <Badge variant="blue">{selectedEmploye.contrat}</Badge>



                    </div>



                  </div>



                </div>



                <button onClick={() => setSelectedEmploye(null)} style={{ background: 'none', border: 'none', color: '#889', fontSize: 28, cursor: 'pointer', lineHeight: 1 }}>?</button>



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 24 }}>



                {[



                  { label: 'Score', value: selectedEmploye.score + '/10', color: selectedEmploye.color },



                  { label: 'Taches', value: `${selectedEmploye.tachesDone}/${selectedEmploye.tachesQuot}`, color: '#42a5f5' },



                  { label: 'Objectifs', value: (selectedEmploye.objectifs || []).length, color: '#ab47bc' },



                ].map((stat, i) => (



                  <div key={i} style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 10, padding: 16, textAlign: 'center' }}>



                    <div style={{ fontSize: 24, fontWeight: 700, color: stat.color, marginBottom: 4 }}>{stat.value}</div>



                    <div style={{ fontSize: 11, color: '#667' }}>{stat.label}</div>



                  </div>



                ))}



              </div>



              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12, color: '#C9A84C' }}>🔹 Objectifs ({(selectedEmploye.objectifs || []).length})</div>



              {(selectedEmploye.objectifs || []).length === 0



                ? <div style={{ padding: 16, textAlign: 'center', color: '#667', fontSize: 12 }}>Aucun objectif.</div>



                : (selectedEmploye.objectifs || []).map((obj, idx) => (



                  <div key={obj.id || idx} style={{ padding: 12, background: 'rgba(255,255,255,0.03)', borderRadius: 8, marginBottom: 10, borderLeft: `3px solid ${obj.statut === 'atteint' ? '#66bb6a' : obj.statut === 'retard' ? '#ef5350' : '#ff9800'}` }}>



                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>



                      <span style={{ fontSize: 13 }}>{obj.titre}</span>



                      <Badge variant={obj.statut === 'atteint' ? 'green' : obj.statut === 'retard' ? 'red' : 'orange'}>



                        {obj.statut === 'atteint' ? 'Atteint' : obj.statut === 'retard' ? 'Retard' : 'En cours'}



                      </Badge>



                    </div>



                    <Pbar pct={obj.progression} />



                  </div>



                ))



              }



              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>



                <button onClick={() => { openModal('employe', { ...selectedEmploye, _isEdit: true }); setSelectedEmploye(null); }} style={{ background: 'rgba(201,168,76,0.2)', border: '1px solid rgba(201,168,76,0.4)', borderRadius: 8, padding: '10px 20px', color: '#C9A84C', fontSize: 13, cursor: 'pointer' }}>🔹 Modifier</button>



                <button onClick={() => setSelectedEmploye(null)} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 20px', color: '#aaa', fontSize: 13, cursor: 'pointer' }}>Fermer</button>



              </div>



            </div>



          </div>



        )}



      </div>



    </MainLayout>



  );



}







export default DashboardComptabilitePage;





